
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { DataService } from '@/service/DataService';
import Popup from '@/components/utils/Popup.vue';
import RemoveRoomOrSpacePopup from '@/components/popup/common/RemoveRoomOrSpacePopup.vue';
import AddOrEditSpacePopup from '@/components/popup/home/AddOrEditSpacePopup.vue';
import { RoomSpace, User } from '@/utils/models';
import { isAdmin } from '@/utils/functions';

@Component({ components: { AddOrEditSpacePopup, RemoveRoomOrSpacePopup, Popup } })
export default class Spaces extends Vue {
  @Prop() dataServiceRef!: DataService;
  @Prop() selectedSpace!: RoomSpace;
  @Prop() spacesState!: RoomSpace[];
  @Prop() user!: User;
  @Prop() searchType!: string;
  @Emit()
  setSelectedSpace(space: RoomSpace) {}

  isAddModalVisible = false;
  spaceToDelete: RoomSpace | null = null;
  isRemoveSpacePopupVisible = false;
  isSpaceEdit = false;
  menuTarget: RoomSpace | null = null;
  menuTargetTop = 0;
  isAdminMenuHovered = false;
  hoveredTarget: RoomSpace | null = null;

  get selected(): RoomSpace {
    return this.selectedSpace;
  }
  get spaces(): RoomSpace[] {
    return this.spacesState.filter((s) => s.spaceType !== 'trash');
  }
  get isAdmin(): boolean {
    return isAdmin(this.user);
  }
  showAddModal(): void {
    this.isAddModalVisible = true;
  }

  showEditPopup(): void {
    if (!this.menuTarget) {
      return;
    }
    this.isSpaceEdit = true;
    this.isAddModalVisible = true;
    this.setSelectedSpace(this.menuTarget);
  }
  openMenu(space: RoomSpace, ev: MouseEvent) {
    this.menuTarget = space;
    const parentEl = (ev.currentTarget as HTMLElement)?.offsetParent as HTMLElement;
    const offsetEl = parentEl?.offsetParent as HTMLElement;
    if (parentEl && offsetEl) {
      this.menuTargetTop = Math.min(
        parentEl.getBoundingClientRect().top - offsetEl.offsetTop + window.scrollY,
        window.innerHeight - 100,
      );
    } else {
      this.menuTargetTop = 0;
    }
  }

  showRemovePopup(): void {
    if (!this.menuTarget) {
      return;
    }
    this.spaceToDelete = this.menuTarget;
    this.isRemoveSpacePopupVisible = true;
    this.hideMenu();
  }

  hideRemoveAndEditSpacePopup(): void {
    this.isRemoveSpacePopupVisible = false;
    this.hideMenu();
  }

  removeSpace(space: string): void {
    this.hideRemoveAndEditSpacePopup();
    this.dataServiceRef.emitRemoveSpace(this.spaceToDelete!.id);
    this.spaceToDelete = null;
  }

  hideAddModal(): void {
    this.isAddModalVisible = false;
    this.isSpaceEdit = false;
  }
  hideMenu() {
    this.menuTarget = null;
  }
  showAdminMenu(space: RoomSpace): void {
    this.hoveredTarget = space;
    if (this.hoveredTarget) {
      this.isAdminMenuHovered = true;
    }
  }
  hideAdminMenu(): void {
    this.isAdminMenuHovered = false;
  }
}
